/*
 * @Descripttion: 设置头部路由
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-21 18:59:00
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-09-09 09:54:37
 */
// permission_routes

// import Router from 'vue-router'
import router, { resetRouter } from '@/router'
import { deepClone } from './index'

export const getRoutes = (routes) => {
  routes = deepClone(routes)
  const grade1 = routes.filter((item) => item.children && item.children.length > 0 && item.children[0].meta.grade === 1)
  const grade2 = routes.filter((item) => item.children && item.children.length > 0 && item.children[0].meta.grade === 2)
  const arr = deepClone(grade1)
  for (let i = 0; i < arr.length; i++) {
    for (let j = 0; j < grade2.length; j++) {
      if (arr[i].children[0].meta.gradePath === grade2[j].children[0].meta.gradePath) {
        const children = grade2.filter((item) => item.children && item.children.length > 0 && item.children[0].meta.gradePath === grade1[i].children[0].meta.gradePath)
        if (grade1[i].children[0].children === undefined) {
          arr[i].children[0].meta.title = arr[i].children[0].title
          arr[i].children[0].children = grade1[i].children
          children.forEach(item => {
            const index = arr[i].children[0].children.filter(($item) => $item.path !== item.path)
            if (index !== -1) {
              item.children[0].path = item.path
              arr[i].children[0].children.push(item.children[0])
            }
          })
        }
      }
    }
  }
  return arr
}

// 对路由进行排序
export function setRoutesSort (routes) {
  const routeArr = []
  const tailArr = []
  for (let i = 0; i < routes.length; i++) {
    if (routes[i].meta && routes[i].meta.sort) {
      routeArr.push(routes[i])
    } else {
      tailArr.push(routes[i])
    }
  }
  for (let i = 0; i < routeArr.length - 1; i++) {
    for (let j = 0; j < routeArr.length - i - 1; j++) {
      if (routeArr[j].meta.sort > routeArr[j + 1].meta.sort) {
        const route = routeArr[j]
        routeArr[j] = routeArr[j + 1]
        routeArr[j + 1] = route
      }
    }
  }
  return routeArr.concat(tailArr)
}

export function setRoutes (routes) {
  // router.matcher = new Router().matcher
  resetRouter()
  routes.forEach(item => {
    router.addRoute(item)
  })
}
